import { menuItems } from "@peracto/peracto";

export const menu = {
    ...menuItems,
};
